var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-row"},_vm._l((_vm.images),function(url,i){return _c('img',{key:i,attrs:{"src":url}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }